import { render } from "./bulkSupplierFZFQualityDataList.vue?vue&type=template&id=49275b40&scoped=true"
import script from "./bulkSupplierFZFQualityDataList.vue?vue&type=script&lang=js"
export * from "./bulkSupplierFZFQualityDataList.vue?vue&type=script&lang=js"

import "./bulkSupplierFZFQualityDataList.vue?vue&type=style&index=0&id=49275b40&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49275b40"]])

export default __exports__